import Vue from "vue";

// vue-toasted puts a string message in innerHTML. Messages often carry
// user data (names, e-mails, server errors), so a string is always shown
// as plain text; build a DOM node for anything richer (it is appended as
// is, see the accepted request toast).
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function showErrorToast(message: string) {
  showToast(message, { type: "error" });
}

export function showToast(
  message: string | HTMLElement,
  config: {
    position?: string;
    type?: string;
    duration?: number;
    action?: any;
  } = {
    position: "bottom-right",
    type: "success",
    duration: 2000,
  }
) {
  const content =
    message instanceof HTMLElement
      ? message
      : escapeHtml(message == null ? "" : String(message));
  Vue?.toasted?.show(content as any, {
    position: config.position || "bottom-right",
    type: config.type || "success",
    duration: config.duration || 1000,
    keepOnHover: true,
    ...(config.action ? { action: config.action } : {}),
  } as any);
}
